import type { BlockchainAction } from "@opensea/graphql"
import { graphql } from "@opensea/graphql"
import { $tada, type TadaDocumentNode } from "gql.tada"
import { useScheduler_actionFragment } from "../../polychain/hooks/useScheduler.fragment"
import { ActionTimelineItemFragment } from "./ActionTimelineItem.fragment"

// Explicitly defining the type to circumvent TypeScript’s type inference limitations
// https://github.com/microsoft/TypeScript/issues/57878
export const ActionTimelineFragment: TadaDocumentNode<
  {
    __typename: BlockchainAction["__typename"]
    [$tada.fragmentRefs]: { useScheduler_action: "BlockchainAction" } & {
      ActionTimelineItem: "BlockchainAction"
    }
  },
  Record<string, never>,
  { fragment: "ActionTimeline"; on: "BlockchainAction"; masked: true }
> = graphql(
  `
    fragment ActionTimeline on BlockchainAction {
      __typename
      ...useScheduler_action
      ...ActionTimelineItem
    }
  `,
  [useScheduler_actionFragment, ActionTimelineItemFragment],
)
